import axios from 'axios';

export const getAuditTrailService = async (filter, limit = 1000) => {
  const response = await axios.post('/audits/search', {
    limit,
    offset: 0,
    filter,
  });
  return response.data?.data;
};

/**
 * GET /audits/command-number. Fetched before every master-control send.
 * @param {string} actionType  an ACTION_TYPES value
 * @returns {Promise<number>}
 */

export const getCommandNumberService = async (actionType) => {
  const response = await axios.get(`/audits/command-number?actionType=${actionType}`);
  return response.data?.commandNumber;
};

export const getAllUsers = async () => {
  const response = await axios.get('/users');
  return response.data?.data;
};

/**
 * POST /audits/: ask for a PDF (audit trail) or log a telemetry overview.
 * @param {import('../helpers/payloads/auditTrailPrintPayload').AuditTrailPrintPayload | Object} data
 *   `auditTrailPrintPayload`, `buildTelemetryAuditLog`, or the inline telemetry logs in MainSelections
 * @returns {Promise<*>}
 */

export const postAuditTrailLogService = async (data) => {
  const response = await axios.post('/audits/', data);
  return response.data?.data;
};
